import ApiClient from '../ApiClient';

const LeadService = {
  async getLeads() {
    const resp = await ApiClient.get(`/lead/leads-dashboard`);
    return resp;
  },

  async addLead(lead) {
    console.log('LeadService.addLead called with:', lead);
    const resp = await ApiClient.post(`/lead/add-lead-request`, lead);
    return resp;
  },

  async updateLead(lead) {
    console.log('LeadService.updateLead called with:', lead);
    const resp = await ApiClient.put(`/lead/update-lead`, lead);
    console.log('update lead response:', resp);
    return resp;
  },

  async getLeadsInfo() {
        const resp = await ApiClient.get(`/lead/leads`);
        return resp;
    },
};

export default LeadService;
